import { MARIGOLD } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function getStatusMessage(isAwayMode) {
  // using I18n.text because this is for `aria-label` which can't take an Element
  if (isAwayMode) {
    return I18n.text('routing-ui.agent-status.agentIsAway');
  } else {
    return I18n.text('routing-ui.agent-status.agentIsAvailable');
  }
}
const AvailabilityIndicatorDot = ({
  isAwayMode
}) => /*#__PURE__*/_jsx(UIStatusDot, {
  "aria-label": getStatusMessage(isAwayMode),
  "data-test-id": "agent-status-available-indicator",
  role: "img",
  style: {
    height: 8,
    width: 8
  },
  use: isAwayMode ? 'default' : 'success'
});
AvailabilityIndicatorDot.displayName = 'AvailabilityIndicatorDot';
const OverCapacityIndicator = () => /*#__PURE__*/_jsx(UITooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.agent-status.maxCapacityTooltip"
  }),
  children: /*#__PURE__*/_jsx(UIIcon, {
    className: "m-right-2",
    color: MARIGOLD,
    "data-test-id": "agent-status-at-capacity-indicator",
    name: "warning",
    style: {
      marginBottom: -4
    }
  })
});
OverCapacityIndicator.displayName = 'OverCapacityIndicator';
const Indicator = ({
  isAwayMode,
  atCapacity
}) => {
  return atCapacity ? /*#__PURE__*/_jsx(OverCapacityIndicator, {}) : /*#__PURE__*/_jsx(AvailabilityIndicatorDot, {
    isAwayMode: isAwayMode
  });
};
Indicator.displayName = 'Indicator';
const AvailabilityIndicator = ({
  isAwayMode,
  atCapacity
}) => {
  return /*#__PURE__*/_jsx(Indicator, {
    isAwayMode: isAwayMode,
    atCapacity: atCapacity
  });
};
AvailabilityIndicator.displayName = 'AvailabilityIndicator';
export default AvailabilityIndicator;